import { all } from "redux-saga/effects";
import { watchForms } from "@common/redux/forms/sagas";
import { watchFolders } from "@common/redux/folders/sagas";
import { watchFormSubmission } from "@common/redux/formSubmission/sagas";
import { watchAuth } from "@common/redux/auth/saga";
import { watchProfile } from "@common/redux/profile/saga";
import { watchFiles } from "@common/redux/upload/saga";
import { watchCommon } from "@common/redux/common/saga";
import { watchFormBuilder } from "@common/redux/formBuilder/sagas";
import { watchPayment } from "@common/redux/payment/sagas";
import { watchTheme } from "@common/redux/theme/sagas";
import { watchSubscription } from "@common/redux/subscription/sagas";
import { watchAdminPanel } from "@common/redux/admin/saga";
import { watchConfig } from "@common/redux/config/saga";
import { watchTemplates } from "@common/redux/templates/sagas";
export default function* rootSaga(): Generator {
  yield all([
    watchFormSubmission(),
    watchForms(),
    watchTemplates(),
    watchFolders(),
    watchAuth(),
    watchProfile(),
    watchFiles(),
    watchCommon(),
    watchFormBuilder(),
    watchPayment(),
    watchTheme(),
    watchSubscription(),
    watchAdminPanel(),
    watchConfig(),
  ]);
}
